import { useEffect, useState } from "react";
import "../css/admin.css";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import MerlinDB from "@chrisaxxwell/merlin-db";
import { schemaGuides } from "./reference";
import axios from "axios";
import Head from "./head";
var merlin = MerlinDB();
merlin.connect("merlinDB");

var schemaSearch = merlin.Schema({
   username: String,
   password: {
      type: Array,
      encrypt: {
         strength: "medium"
      }
   }
});

var model = merlin.model("login", schemaSearch);
var hash = "a69f73cca23a9ac5c8b567dc185a756e97c982164fe25859e0d1dcc1475c80a615b2123af1f5f94c11e3e9402c3ac558f500199d95b6d3e301758586281dcd26";
var aes = "EkQnKrhKbHoEnuRR5gEQay6ym1f1CbXcyZ+qeijxJSHo4KwSM0UQwqWkC+Vq9f3c2te40yFcu8Mb4ZSDe5Vpj15FJqfA+w9p0XJc3dE67I6XHHkxp1iXSa/fbdPdUYChnpCukU8kI1Oj5EC7AUNqTwYQYqn5gR2U/JAiGk11t+FnDuWljnoZfVu8ryVNu0+WmEVA4wSN4p7ohJeXwIQRgQ==";

merlin.getModel("login").catch(e => {
   model.insertOne({
      username: "@chrisaxxwell",
      password: [ hash, "decrypt 88" ]
   }).then(e => {
   }).catch(e => { });
});

function isLogged() {
   return window.localStorage.getItem("access-token")
}

function EditButton() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 22 22" version="1.1">
         <path d="M16.989778,15.9532516 C17.5468857,15.9532516 18,16.412265 18,16.9766258 C18,17.5420615 17.5468857,18 16.989778,18 L16.989778,18 L11.2796888,18 C10.7225811,18 10.2694668,17.5420615 10.2694668,16.9766258 C10.2694668,16.412265 10.7225811,15.9532516 11.2796888,15.9532516 L11.2796888,15.9532516 Z M13.0298561,0.699063657 L14.5048652,1.87078412 C15.109725,2.34377219 15.5129649,2.96725648 15.6509154,3.62298994 C15.810089,4.34429676 15.6403038,5.0527039 15.1627829,5.66543845 L6.37639783,17.027902 C5.97315794,17.543889 5.37890967,17.8341317 4.74221511,17.8448814 L1.24039498,17.8878803 C1.04938661,17.8878803 0.890212963,17.7588836 0.847766658,17.5761382 L0.051898447,14.1254752 C-0.086052043,13.4912412 0.051898447,12.8355077 0.455138341,12.3302704 L6.68413354,4.26797368 C6.7902493,4.13897694 6.98125767,4.11855245 7.10859659,4.21422504 L9.7296559,6.29967247 C9.89944111,6.43941894 10.1328958,6.51466705 10.376962,6.48241786 C10.8969293,6.41791948 11.2471113,5.94493141 11.1940534,5.43969415 C11.1622187,5.18170065 11.0348798,4.96670607 10.8650945,4.80546013 C10.8120367,4.76246122 8.31831627,2.76301162 8.31831627,2.76301162 C8.15914263,2.63401488 8.1273079,2.39752084 8.25464681,2.23734988 L9.24152339,0.957057153 C10.1541189,-0.214663308 11.7458554,-0.322160598 13.0298561,0.699063657 Z" />
      </svg>
   )
}

function RemoveButton() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" version="1.1">
         <path d="M15.9390642,6.69713303 C16.1384374,6.69713303 16.3193322,6.78413216 16.4622974,6.93113069 C16.5955371,7.08812912 16.6626432,7.28312717 16.6431921,7.48912511 C16.6431921,7.55712443 16.1102334,14.297057 15.8058245,17.1340287 C15.6152042,18.8750112 14.4928788,19.9320007 12.8093905,19.9610004 C11.5149233,19.9900001 10.2496326,20 9.00379295,20 C7.68112168,20 6.38762697,19.9900001 5.13206181,19.9610004 C3.50498163,19.9220008 2.3816836,18.8460115 2.20078885,17.1340287 C1.88762697,14.2870571 1.36439378,7.55712443 1.35466825,7.48912511 C1.34494273,7.28312717 1.41107629,7.08812912 1.54528852,6.93113069 C1.67755565,6.78413216 1.86817592,6.69713303 2.06852172,6.69713303 L15.9390642,6.69713303 Z M11.0647288,-2.48689958e-14 C11.9487789,-2.48689958e-14 12.7384915,0.61699383 12.9670413,1.49698503 L12.9670413,1.49698503 L13.1304301,2.22697773 C13.2626972,2.82197178 13.77815,3.24296757 14.371407,3.24296757 L14.371407,3.24296757 L17.2871191,3.24296757 C17.67614,3.24296757 18,3.56596434 18,3.97696023 L18,3.97696023 L18,4.35695643 C18,4.75795242 17.67614,5.09094909 17.2871191,5.09094909 L17.2871191,5.09094909 L0.713853469,5.09094909 C0.323859952,5.09094909 1.95399252e-14,4.75795242 1.95399252e-14,4.35695643 L1.95399252e-14,4.35695643 L1.95399252e-14,3.97696023 C1.95399252e-14,3.56596434 0.323859952,3.24296757 0.713853469,3.24296757 L0.713853469,3.24296757 L3.62956559,3.24296757 C4.22185001,3.24296757 4.73730279,2.82197178 4.87054247,2.22797772 L4.87054247,2.22797772 L5.0232332,1.54598454 C5.26053598,0.61699383 6.04149557,-2.48689958e-14 6.93527123,-2.48689958e-14 L6.93527123,-2.48689958e-14 Z" />
      </svg>
   )
}

function findContents(setContents) {
   merlin.getModel("guides-content").then(() => {
      var modelContent = merlin.model("guides-content", schemaGuides);

      modelContent.find({}).then((e) => {
         setContents(e);
      }).catch(e => { });
   }).catch(() => {
      setContents([]);
   })
}

function deleteContent(id, setContents) {
   var modelContent = merlin.model("guides-content", schemaGuides);

   modelContent.findByIdAndDelete(id).then(e => {
      findContents(setContents);
   });
}

function updateContent(key, value) {
   var id = key.id;
   var tag = key.key;
   tag = `content.${tag}`;

   var modelContent = merlin.model("guides-content", schemaGuides);

   modelContent.findOneAndUpdate(
      {
         name: id
      },
      {
         $set: {
            [ tag ]: value
         }
      }
   ).then(e => { }).catch(e => { });
}

function dropAllContents(setContents) {
   var modelContent = merlin.model("guides-content", schemaGuides);
   modelContent.deleteMany({}).then(() => {
      findContents(setContents);
   }).catch(() => { });
}

async function recoveryContent(setContents) {
   var { data } = await axios.get("/json/guides-content-en.json");
   var recoveryModel = merlin.model("guides-content", schemaGuides);

   recoveryModel.insert(data).then(() => {
      findContents(setContents)
   });
}

//Components path
function DashBoard() {
   var nav = useNavigate();
   var [ contents, setContents ] = useState([]);

   useEffect(() => {
      if (!isLogged()) {
         return nav("/admin")
      }

      window.scrollTo(0, 0);
      findContents(setContents);
   }, [ nav ]);

   return (
      <main id="dashboard">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "profile",
            title: "DashBoard - MerlinDB",
            description: "",
            page_author: "Chris Axxwell",
            index: "noindex, nofollow, noarchive",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados",
            canonical: "/admin/dashboard",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg",
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg",
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
         }} />
         <h1>DashBoard</h1>
         <h5>The data below is inserted into IndexedDB using MerlinDB, you can change the contents of this website but it will only be changed on your computer. This is just an illustration of how this tool works. Have fun.</h5>
         <div>
            <div>
               <h4>Contents <button onClick={() => {
                  dropAllContents(setContents);
               }}>Drop All</button></h4>
               <div>
                  {
                     contents && contents.length !== 0 ? (
                        contents.map((e, i) => (
                           <p key={i}>{e.name} <Link title="Click on the texts to edit!!" to={'/manual/reference/' + e.name + '?edit=true'}><EditButton /></Link><button title="Using `.findByIdAndDelete(<id>)` method" onClick={() => {
                              deleteContent(e.id_, setContents)
                           }}><RemoveButton /></button></p>
                        ))
                     ) : (
                        <>
                           <span>0 contents founded!</span>
                           <button onClick={() => {
                              recoveryContent(setContents);
                           }}>Recovery all content</button>
                        </>
                     )
                  }
               </div>
            </div>
         </div>
      </main>
   )
}

function Login() {
   var [ originalHash, setOriginalHash ] = useState('encrypted');
   var nav = useNavigate();

   useEffect(() => {
      if (isLogged()) {
         return nav("dashboard")
      }

      window.scrollTo(0, 0);
   }, [ nav ])

   function ErrorMessage(passInput) {
      passInput.value = '';
      passInput.placeholder = 'Invalid password, type "decrypt 88"';
      passInput.className = 'invalid';

      setTimeout(() => {
         passInput.className = '';
      }, 2000);
   }

   function loginValidate(e) {

      if (e.type === 'keydown' && e.keyCode !== 13) return;

      var inputs = e.target.parentElement;
      inputs = inputs.querySelectorAll("input, button");
      inputs[ 1 ].className = '';

      if (inputs[ 1 ].value === '') {
         ErrorMessage(inputs[ 1 ]);
         return;
      }

      inputs[ 2 ].className = "validating";
      model.findOne({
         username: inputs[ 0 ].value,
      }, {
         decrypt: {
            secretKey: inputs[ 1 ].value,
            fields: [ "password" ],
            strength: "medium"
         }
      }).then(e => {

         setOriginalHash(e.password);
         setTimeout(() => {
            window.localStorage.setItem("access-token", e.password);
            nav("dashboard");
         }, 2000);

      }).catch(() => {
         inputs[ 2 ].className = "";
         ErrorMessage(inputs[ 1 ]);
      });
   }
   return (
      <main id="login">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "article",
            title: "Login - MerlinDB",
            description: "",
            page_author: "Chris Axxwell",
            index: "noindex, nofollow",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados",
            canonical: "/admin",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg",
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg",
            noCache: false,
         }} />
         <h1>Login</h1>
         <h5>This session is a fictitious login, simulating the tool.</h5>
         <input type='text' defaultValue="@chrisaxxwell" />
         <input onKeyDown={loginValidate} type='password' placeholder="password is 'decrypt 88'" />
         <p>The above data is being encrypted using Merlin Decrypt. First you enter the password and then create a secret key to access.</p>
         <button onClick={loginValidate}>Enter the test Dashboard</button>

         <p><strong className="schema4">&gt;= Original Hash</strong>: {originalHash}</p>
         <p title={aes}><strong className="schema4">&gt;= AES Escrypted</strong>:  {aes}  </p>
      </main>
   )
}

export default function Admin() {

   return (
      <Routes>
         <Route path="*" Component={Login} />
         <Route path="dashboard" Component={DashBoard} />
      </Routes>
   )
}

export { updateContent }